module.exports = __webpack_public_path__ + "static/media/Travonga-Screenshot.215857ee.jpg";